import { render, staticRenderFns } from "./ConsumableQuery.vue?vue&type=template&id=4aead74d&scoped=true"
import script from "./ConsumableQuery.vue?vue&type=script&lang=js"
export * from "./ConsumableQuery.vue?vue&type=script&lang=js"
import style0 from "./ConsumableQuery.vue?vue&type=style&index=0&id=4aead74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aead74d",
  null
  
)

export default component.exports